import { IPlanFeatures } from "shared";

import { useGetSubscriptionMetadata } from "./useGetSubscription";

export function useAllowedFeature(feature: keyof IPlanFeatures) {
  const { subscriptionMetadata } = useGetSubscriptionMetadata();

  return !!subscriptionMetadata?.features?.[feature];
}
